import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  MixedGridGroup,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  useQuantaFormikContext,
  Text,
  QuantaInput,
  QuantaButton,
  InputGridGroup,
  QuantaDateInput,
  Grid,
  GridItem,
  // renderExpandedCards
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamation,
  faInfoCircle,
  faSearch,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
// import { updateMotorQuote } from '../../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import VehicleDataModal from './vehicle-data-modal';
import PreviousInsurance from './previous-insurance-claims/previous-insurance';
import PreviousClaims from './previous-insurance-claims/previous-claims';
import InsuredDeclaredForm from './insured-declared-form';
import IRFForm from './Irfform';
import Discounts from './discounts';
//import Trailers from './trailers-bkp';
import Trailers from './trailers';
// import CoversForm from './coverdata';
import { useQuery } from '@apollo/client';
import {
  VEHICLE_DETAILS,
  GET_PCV_POLICY_VAR_DETAILS,
  PRODUCT_TYPE_LIST,
  PCV_BUSINESS_TYPE,
  DISCOUNT_DROPDOWN_DETAILS,
  CLAIM_DETAILS,
  PRODUCT_VARIANT,
  APPLICABLE_COVERS,
  GET_FIELDUSER_LIST,
  CHARACTER_LIMIT_LIST,
  GET_BUSINESS_TYPE_PCV,
  GET_TOWEDBY_PCV,
  GET_NO_OFTRAILERS_PCV,
  RTO_LIST_BRAND_LIST_YEAR_RANGE,
  MODEL_DETAILS,
  VARIANT_DETAILS,
  GET_RTO_DETAILS,
  GET_SUBPRODUCT_PCV,
} from '../../queries';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';
import VehicleDetails from './vehicle-details';
import { QuantaConfigContext } from 'quanta-flows';
import moment from 'moment';
export default function Vehicle({
  productCode,
  setproceedToCoverPage,
  lobCode,
  productName,
  lobName,
  quoteNumber,
  setParentAlerts,
  productCode1,
  setProductCode,
  modify,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  let repeat_for_mobile = 1;
  let repeat_for_desktop = 3;
  const { branding } = useContext(QuantaConfigContext);
  let repeat = useResponsiveParams({
    for_mobile: repeat_for_mobile,
    for_desktop: repeat_for_desktop,
  });
  const [initialValues, setInitialValues] = useState(null);
  const initLoadRef = useRef([]);
  const [loadingCovers, setLoadingCovers] = useState(false);
  const [errorCovers, setErrorCovers] = useState(null);
  const [coversInfo, setCoversInfo] = useState(null);
  const [initLoad, setInitLoad] = useState(true);
  const [fieldUserList, setFieldUserList] = useState([]);
  const [productloading, setproductloading] = useState('3183');
  const {
    loading: loadingMotorQuote1,
    error: errorMotorQuote1,
    data: dataMotorQuote,
    previousData: previousDataMotorQuote,
  } = useQuery(GET_PCV_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: !initLoad,
    onCompleted: async (data) => {
      const { motorQuote, selectedIntermediary } = data;
      try {
        setErrorCovers(null);
        const applicableCoversQuery = fetchQuery({
          query: APPLICABLE_COVERS,
          fetchPolicy: data?.motorQuote?.quotationNo
            ? 'cache-first'
            : 'network-only',
          variables: {
            input: {
              productCode: productCode1,
              productType: data?.motorQuote?.productType,
              intermediaryCode:
                data?.selectedIntermediary?.intermediaryCode,
              fuelType: data?.motorQuote?.fuelType,
            },
          },
        });
        const getFieldUserList = fetchQuery({
          query: GET_FIELDUSER_LIST,
          variables: {
            input: {
              intermediaryCode:
                motorQuote?.intermediaryDetails?.code ||
                selectedIntermediary?.intermediaryCode,
              officeId:
                motorQuote?.intermediaryDetails?.location ||
                selectedIntermediary?.branchOfficeCode,
            },
          },
        });
        setLoadingCovers(true);
        const { data: coversData } = await applicableCoversQuery;
        setCoversInfo(coversData);
        setInitialValues(data?.motorQuote);
        const { data: dataFieldUserList } = await getFieldUserList;
        setInitLoad(false);
        setFieldUserList(dataFieldUserList?.getFiledUserByIMID);
        setLoadingCovers(false);
      } catch (error) {
        setLoadingCovers(false);
        setErrorCovers(error?.message);
      }
    },
  });

  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: dataBusinessType,
  } = useQuery(GET_BUSINESS_TYPE_PCV, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        productCode: 'All',
        domainType: 'Business Type PCV',
      },
    },
    onCompleted: (data) => {},
  });

  const { loading: loadingMotorQuote, error: errorMotorQuote } =
    useQuery(GET_PCV_POLICY_VAR_DETAILS, {
      fetchPolicy: 'cache-first',
      skip: new Set(initLoadRef?.current).size >= 3 ? true : false,
      onCompleted: (data) => {
        setInitialValues(data?.motorQuote);
        initLoadRef.current = [...initLoadRef.current, 1];
      },
    });
  const { loading: loadingDiscountData, data: discountData } =
    useQuery(DISCOUNT_DROPDOWN_DETAILS, {
      fetchPolicy: 'cache-first',
      variables: {
        productCode,
      },
      onCompleted: (data) => {
        initLoadRef.current = [...initLoadRef.current, 2];
      },
    });

  const {
    loading: loadingProductType,
    error: errorProductType,
    data: productTypeData,
  } = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });
  const {
    loading: loadingProductVariant,
    error: errorProductVariant,
    data: productVariantTypeData,
  } = useQuery(PRODUCT_VARIANT, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        productCode: 'All',
        domainType: 'Product Variant PCV',
      },
    },
    onCompleted: (data) => {},
  });
  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
    previousData: previousDataNameLimit,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
    skip: !initLoad,
  });
  const {
    loading: loadingtowedby,
    error: errortowedby,
    data: datatowedby,
  } = useQuery(GET_TOWEDBY_PCV, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        productCode: 'All',
        domainType: 'TowedBy PCV',
      },
    },
    onCompleted: (data) => {},
  });
  const {
    loading: loadingnooftrailers,
    error: errornooftrailers,
    data: datanooftrailers,
  } = useQuery(GET_NO_OFTRAILERS_PCV, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        productCode: 'All',
        domainType: 'NoofTrailers PCV',
      },
    },
    onCompleted: (data) => {},
  });
  if (loadingtowedby || loadingnooftrailers) {
    return (
      <div className="min-h-full">
        <Loading customMessage={'Fetching details'} />
      </div>
    );
  }

  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  if (
    loadingProductType ||
    loadingMotorQuote ||
    loadingDiscountData ||
    loadingProductVariant ||
    loadingCovers ||
    loadingMotorQuote1 ||
    loadingNameLimit ||
    loadingBusinessType
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (errorProductType || errorMotorQuote) {
    return <Error error={errorProductType || errorMotorQuote} />;
  }
  const { lobProductList } = productTypeData;
  const {
    PRD_vehicleOwnedByList,
    PRD_IDProofTypeForCreditScoreList,
    PRD_VoluntaryDeductibleAmount,
  } = discountData;
  const productVariantList = productVariantTypeData?.getDomainData;
  const { motorQuote, selectedIntermediary } = dataMotorQuote
    ? dataMotorQuote
    : previousDataMotorQuote;
  const { characterLimitList } = dataNameLimit
    ? dataNameLimit
    : previousDataNameLimit;
  const mapdataBusinessType = dataBusinessType?.getDomainData;
  const mapdatatowedby = datatowedby?.getDomainData;
  const mapdatanooftrailers = datanooftrailers?.getDomainData;
  const validate = (values) => {
    let errors = {};
    let errorCount = 0;
    let stateCode = /^([a-zA-Z]){2}?$/;
    let BHstateCode = /^([0-9]){2}?$/;
    let distCode = /^([a-zA-Z0-9]){2}?$/;
    let BHdistCode = /^([a-zA-Z]){2}?$/;
    let uniqueCode = /^[A-Za-z\s]*$/
    // let uniqueCode = /^([a-zA-Z]){2}?$/;
    // let uniqueCode = /^([a-zA-Z])?$/;
    let BHuniqueCode = /^([0-9]){3}?$/;
    let uniqueNumber = /^([0-9]){4}?$/;
    let BHuniqueNumber = /^([a-zA-Z]){2}?$/;
    // if (!values?.productType) {
    //   errors.productType = '* Required';
    // }
    if (!values?.productVariant) {
      errors.productVariant = '* Required';
      errorCount+=1;
    }
    let vehregno= `${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}`;
    
    if(vehregno?.toLowerCase()==='ap39'&&!values?.rtoAuthorityCode?.includes('AP'))
      {
        errors.regNo = ' *For AP39 Registration Numbers, RTO must belong to Andhra Pradesh(AP) only';
      }
    if (
      moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) >
      473353890000
    ) {
      errors.businessType =
        '* Vehicle age cannot be greater than 15 years';
        errorCount+=1;
    }
    if (values.businessType === 'New Business') {
      if (
        moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) >
        23760000000
      ) {
        errors.businessType =
          '* Vehicle age cannot be greater than 275 days for New Business Type';
          errorCount+=1;
      }
    }
    // if (
    //   productCode1?.toString() === '3151' &&
    //   values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
    //     'yes'
    //   //  && values?.policyCoverType!=='OD Only'
    // ) {
    //   // if (!values?.TP_Policy_Tenure) {
    //   //   errors.TP_Policy_Tenure = '* Required';
    //   // }
    //   if (!values?.TP_Start_Date) {
    //     errors.TP_Start_Date = '* Required';
      // }
    //   if (!values?.TP_End_Date) {
    //     errors.TP_End_Date = '* Required';
    //   }
    // }
    // if (values?.isTrailerRequired == true) {
    //   errors.trailerDetails = values?.trailerDetails?.map((_) => {
    //     return {};
    //   });
    //   // console.log("errors",errors.trailerDetails)

    //   values?.trailerDetails.forEach((_, idx) => {
    //     // console.log("idxxx",idx)
    //     // console.log("values?.trailerDetails[idx].make",values?.trailerDetails)
    //     if (!values?.trailerDetails[idx].make) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         make: '* Required',
    //       };
    //     }
    //     if (!values?.trailerDetails[idx].model) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         model: '* Required',
    //       };
    //     }
    //     if (!values?.trailerDetails[idx].SI) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         SI: '* Required',
    //       };
    //     }
    //     if (!values?.trailerDetails[idx].regnumber) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         regnumber: '* Required',
    //       };
    //     }
    //     if (!values?.trailerDetails[idx].yearofmanufacture) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         yearofmanufacture: '* Required',
    //       };
    //     }
    //     if (!values?.trailerDetails[idx].ChassisNumber) {
    //       errors.trailerDetails[idx] = {
    //         ...errors.trailerDetails[idx],
    //         ChassisNumber: '* Required',
    //       };
    //     }
    //   });
    //   // values?.trailerDetails.forEach((_, idx) => {
    //   //   errorCount += Object.keys(errors.trailerDetails[idx]).length;
    //   // });
    // }
    if (values.businessType === 'New Business') {
      if (moment(new Date(), 'DD/MM/YYYY').diff(
        moment(values?.dateOfReg, 'DD/MM/YYYY'), 'days') >  275
        ) {
        errors.businessType =
          '* Vehicle age cannot be greater than 275 days';
           errorCount+=1;
        }
    }
    if (values.businessType === 'Roll Over') {
      if (moment(new Date(), 'DD/MM/YYYY').diff(
        moment(values?.dateOfReg, 'DD/MM/YYYY'), 'days') <  275
        ){
          errors.businessType =
            '*Vehicle age cannot be less than 275 days';
            errorCount+=1;
        }
    }
    if (values?.businessType?.toLowerCase()=='roll over')
    {
    if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 473353890000 
    &&(values?.productVariant?.toLowerCase()?.search('comprehensive') !== -1)) {
      errors.businessType =
        '* Vehicle age cannot be greater than 15 years';
        errorCount+=1;
    }
    if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 473353890000
    &&(values?.productVariant?.toLowerCase()?.search('liability') !== -1)&&(values?.vehicleuse?.value?.includes('C1B')) ){
      errors.businessType =
        '* Vehicle age cannot be greater than 15 years';
        errorCount+=1;
    }
  }
  if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 473353890000
  &&(values?.productVariant?.toLowerCase()?.search('liability') !== -1)&&(!values?.vehicleuse?.value?.includes('C2A')) ){
    errors.businessType =
      '* Vehicle age cannot be greater than 15 years';
      errorCount+=1;
  }

    // if (values.productType === 'ODOnly') {
    //   if (
    //     moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) < 315576000000
    //   ) {
    //     // console.log(`134`, moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')))
    //     errors.productType =
    //       '* Vehicle age should be greater than 1 Year for ODOnly';
    //       errorCount+=1;
    //   }
    // }
    // if (values.businessType === 'Roll Over') {
    //   if (
    //     values.productType === 'Kotak Car Secure (1+1)' ||
    //     values.productType ===
    //       'Kotak Car Secure Liability Only –1 years' ||
    //     values.productType === 'Kotak Car Secure OD Only'
    //   ) {
    //     if (
    //       moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) <
    //       78892315000
    //     ) {
    //       errors.productType =
    //         '* Vehicle age should be greater than 2.5 Year for roll over';
    //         errorCount+=1;
    //     }
    //   }
    // }
    if (
      values?.businessType
        ?.toLowerCase()
        ?.trim()
        ?.search('roll over') !== -1
    ) {
      if (
        !values?.vehicleRegNo?.part1 ||
        !values?.vehicleRegNo?.part2 ||
        // !values?.vehicleRegNo?.part3 ||
        !values?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* Required';
        errorCount+=1;
      }
    }
    if (
      values?.vehicleRegNo?.part1 ||
      values?.vehicleRegNo?.part2 ||
      values?.vehicleRegNo?.part3 ||
      values?.vehicleRegNo?.part4
    ) {
      if (
        !values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* State Code is Required';
        errorCount+=1;
      }
      if (
        values?.vehicleRegNo?.part1 &&
        !stateCode.test(values?.vehicleRegNo?.part1) &&
        values?.vehicleRegNo?.bhseries !== true
      ) {
        errors.regNo = '* Enter valid State or Union Territory Code';
        errorCount+=1;
      }
      if (
        values?.vehicleRegNo?.part1 &&
        !BHstateCode.test(values?.vehicleRegNo?.part1) &&
        values?.vehicleRegNo?.bhseries === true
      ) {
        errors.regNo = '* Enter valid year of registration ';
        errorCount+=1;
      }
      const d = new Date();
      let year = d.getFullYear().toString().slice(-2);
      let BHyear = Number(year);
      if (
        values?.vehicleRegNo?.part1 < 21 ||
        (values?.vehicleRegNo?.part1 > BHyear &&
          values?.vehicleRegNo?.bhseries === true)
      ) {
        errors.regNo = '* Enter valid year of registration ';
        errorCount+=1;
      }
      if (
        !values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.part4 &&
        values?.vehicleRegNo?.bhseries !== true
      ) {
        errors.regNo = '* District Sequential Number is Required';
        errorCount+=1;
      }
      if (
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.bhseries !== true
      ) {
        if (!distCode.test(values?.vehicleRegNo?.part2)) {
          errors.regNo = '* Enter valid District Sequential Number';
          errorCount+=1;
        }
      }
      if (
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.bhseries === true
      ) {
        if (
          values?.vehicleRegNo?.part2?.toString()?.toUpperCase() !==
          'BH'
        ) {
          errors.regNo = '* Enter valid Code for Bharat Series';
          errorCount+=1;
        }
      }
      // if (
      //   !values?.vehicleRegNo?.part3 &&
      //   values?.vehicleRegNo?.part1 &&
      //   values?.vehicleRegNo?.part2 &&
      //   values?.vehicleRegNo?.part4
      // ) {
      //   errors.regNo = '* Unique Code is Required';
      //   errorCount+=1;
      // }
      if (values?.vehicleRegNo?.part3) {
        if (!uniqueCode.test(values?.vehicleRegNo?.part3)) {
          errors.regNo = '* Unique Code cannot be alphanumeric';
      }
      }
      if (
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.bhseries === true
      ) {
        if (!BHuniqueCode.test(values?.vehicleRegNo?.part3)) {
          errors.regNo = '*  Unique Number can be only Digits';
          errorCount+=1;
        }
      }
      if (
        !values?.vehicleRegNo?.part4 &&
        values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part3
      ) {
        errors.regNo = '* Unique Number is Required';
        errorCount+=1;
      }
      if (
        values?.vehicleRegNo?.part4 &&
        values?.vehicleRegNo?.bhseries !== true
      ) {
        if (!uniqueNumber.test(values?.vehicleRegNo?.part4)) {
          errors.regNo = '* Unique Number can be only Digits';
          errorCount+=1;
        }
      }
      if (
        values?.vehicleRegNo?.part4 &&
        values?.vehicleRegNo?.bhseries === true
      ) {
        if (!BHuniqueNumber.test(values?.vehicleRegNo?.part4)) {
          errors.regNo = '* Unique Number can be only Alphabets';
          errorCount+=1;
        }
      }
      // if (
      //   values?.vehicleRegNo?.part1 &&
      //   values?.vehicleRegNo?.part2 &&
      //   values?.vehicleRegNo?.part3 &&
      //   values?.vehicleRegNo?.part4 &&
      //   stateCode.test(values?.vehicleRegNo?.part1) &&
      //   distCode.test(values?.vehicleRegNo?.part2) &&
      //   uniqueCode.test(values?.vehicleRegNo?.part3) &&
      //   uniqueNumber.test(values?.vehicleRegNo?.part4) &&
      //   !values?.isRegNoVerified &&
      //   values?.mode === 'online'
      // ) {
      //   errors.regNo =
      //     '* Click the search icon to fetch the Vehicle Details';
      //     errorCount+=1;
      // }
    }
    if (productCode?.toString() !== '3184') {
    if (
      values?.changedIDV === '' ||
      values?.changedIDV === null ||
      values?.changedIDV === undefined
    ) {
      errors.changedIDV = '* Required';
      errorCount+=1;
    }
    if(parseFloat(values?.bodyIDV)> parseFloat(values?.changedIDV)){
      errors.bodyIDV='* Body IDV cannot be Greater than Changed IDV'
      errorCount+=1;
    }
    if (values?.changedIDV) {
      if (
        values?.minSuggestedIDV &&
        parseFloat(values?.changedIDV) <
          parseFloat(values?.minSuggestedIDV)
      ) {
        errors.changedIDV = `* Changed IDV can't be less than ${values?.idvPctMin}% of suggested IDV`;
        errorCount=+1;
      }
      if (
        values?.maxSuggestedIDV &&
        parseFloat(values?.changedIDV) >
          parseFloat(values?.maxSuggestedIDV)
      ) {
        errors.changedIDV = `* Changed IDV can't be greater than ${values?.idvPctMax}% of suggested IDV`;
        errorCount=+1
      }
    }
    // if (
    //   values?.adjustmentIRF === '' ||
    //   values?.adjustmentIRF === null ||
    //   values?.adjustmentIRF === undefined
    // ) {
    //   errors.adjustmentIRF = '* Required';
    // }
    if (
      values?.adjustmentIRF &&
      parseFloat(values?.adjustmentIRF) <
        -parseFloat(values?.irfPctMin)
    ) {
      errors.adjustmentIRF = `* IRF can't be less than -${values?.irfPctMin}%`;
      errorCount+=1;
    }
    if (
      values?.adjustmentIRF &&
      parseFloat(values?.adjustmentIRF) >
        parseFloat(values?.irfPctMax)
    ) {
      errors.adjustmentIRF = `* IRF can't be more than ${values?.irfPctMax}%`;
      errorCount+=1;
    }
    }
    if (!values?.vehicleIsOwnedBy) {
      errors.vehicleIsOwnedBy = '* Required';
      errorCount+=1;
    }
    if (
      values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes' &&
      values?.businessType?.toLowerCase() === 'roll over'
      //  || values?.businessType?.toLowerCase() === 'used car'
    ) {
      if (!values?.policyCoverType) {
        errors.policyCoverType = '* Required';
        errorCount+=1;
      }
      // if (!values?.policyTenure) {
      //  errors.policyTenure = '* Required';
      // }
      if (!values?.policyStartDate) {
        errors.policyStartDate = '* Required';
        errorCount+=1;
      }
      if (
        values?.policyStartDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter()
      ) {
        errors.policyStartDate = '* Cannot accept future date';
        errorCount+=1;
      } else if (
        values?.policyStartDate &&
        values?.policyExpiryDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter(
          moment(values?.policyExpiryDate, 'DD/MM/YYYY'),
        )
      ) {
        errors.policyStartDate = `* Start Date can't be after end date`;
        errorCount+=1;
      }
      if (!values?.policyExpiryDate) {
        errors.policyExpiryDate = '* Required';
        errorCount+=1;
      } else if (
        values?.policyStartDate &&
        values?.policyExpiryDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter(
          moment(values?.policyExpiryDate, 'DD/MM/YYYY'),
        )
      ) {
        errors.policyExpiryDate = `* End date date can't be less than start date`;
        errorCount+=1;
      }
      if (
        values?.policyExpiryDate &&
        moment(values?.policyExpiryDate, 'DD/MM/YYYY').diff(
          moment(
            moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY'),
            'DD/MM/YYYY',
          ),
          'days',
        ) > 90
      ) {
        errors.policyExpiryDate = `Can not choose future date more than 90 days from current date`;
        errorCount+=1;
      }
      // if (
      //   values?.policyExpiryDate &&
      //   moment(values?.policyExpiryDate, 'DD/MM/YYYY')?.isAfter()
      // ) {
      //   errors.policyExpiryDate = '* Cannot accept future date';
      // }
      const expectedTPPolicyEndDate = moment(
        values?.TP_Start_Date,
        'DD/MM/YYYY',
      )
        ?.add(5, 'year')
        ?.subtract(1, 'day');
      if (
        values?.TP_Start_Date &&
        values?.TP_End_Date &&
        expectedTPPolicyEndDate?.toString() !==
          moment(values?.TP_End_Date, 'DD/MM/YYYY')?.toString()
      ) {
        errors.TP_End_Date = `* Date range should be exactly 5 year`;
        errors.TP_Start_Date = `* Date range should be exactly 5 year`;
        errorCount+=1;
      }
      if (
        values?.businessType?.toLowerCase() === 'new business' &&
        values?.policyExpiryDate &&
        moment(values?.policyExpiryDate, 'DD/MM/YYYY')?.isAfter()
      ) {
        errors.policyExpiryDate = '* Cannot accept future date';
      }
      else if (values?.policyExpiryDate && moment(values?.policyExpiryDate, 'DD/MM/YYYY').diff(
        moment(moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY'), 'DD/MM/YYYY'), 'days') > 90)
      {
          errors.policyExpiryDate = `Cannot choose future date more than 90 days from current date`;
      }
      if (values?.policyTenure) {
        // if (
        //   (values?.policyTenureValue
        //     ?.toLowerCase()
        //     ?.search('long term') !== -1 &&
        //     !values?.totalClaimAmount) ||
        //   (values?.policyTenureValue
        //     ?.toLowerCase()
        //     ?.search('annual') !== -1 &&
        //     parseFloat(values?.totalClaimCountValue) !== 0 &&
        //     !values?.totalClaimAmount)
        // ) {
        //   errors.totalClaimAmount = '* Required';
        // }
        if (parseFloat(values?.totalClaimAmount) < 0) {
          errors.totalClaimAmount = '* Amount should be positive';
          errorCount+=1;
        }
        if (!values?.previousYearNCBSlab) {
          errors.previousYearNCBSlab = '* Required';
          errorCount+=1;
        }
        const expectedPolicyEndDateForAnnual = moment(
          values?.policyStartDate,
          'DD/MM/YYYY',
        )
          ?.add(1, 'year')
          ?.subtract(1, 'day');
        if (
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('annual') !== -1 &&
          values?.policyStartDate &&
          values?.policyExpiryDate &&
          expectedPolicyEndDateForAnnual?.toString() !==
            moment(values?.policyExpiryDate, 'DD/MM/YYYY')?.toString()
        ) {
          errors.policyStartDate = `* Date range should be exactly 1 year`;
          errors.policyExpiryDate = `* Date range should be exactly 1 year`;
          errorCount+=1;
        }
      }
      // if (
      //   values?.policyTenureValue
      //     ?.toLowerCase()
      //     ?.search('long term') !== -1
      // ) {
      //   if (!values?.noOfClaimsOneYear) {
      //     errors.noOfClaimsOneYear = '* Required';
      //   }
      //   if (!values?.noOfClaimsTwoYears) {
      //     errors.noOfClaimsTwoYears = '* Required';
      //   }
      //   if (!values?.noOfClaimsThreeYears) {
      //     errors.noOfClaimsThreeYears = '* Required';
      //   }
      // } else if (
      //   values?.policyTenureValue?.toLowerCase()?.search('annual') !==
      //   -1
      // ) {
      //   if (!values?.totalClaimCount) {
      //     errors.totalClaimCount = '* Required';
      //   }
      // }
    }
    if (values.getAdditionalCreditScore === 'Yes') {
      if (!values?.idProofType) {
        errors.idProofType = '* Required';
        errorCount+=1;
      }
      if (!values?.idProofNumber) {
        errors.idProofNumber = '* Required';
        errorCount+=1;
      }
    }
    //check------------------------------------
    if (values.idProofNumber) {
      let regPassport = /^([a-zA-Z]){1}([0-9]){7}?$/;
      if (
        values.idProofType ===
        getDomainData(
          PRD_IDProofTypeForCreditScoreList,
          'Passport',
          'value',
          'code',
        )
      ) {
        if (values.idProofNumber.length !== 8) {
          errors.idProofNumber =
            '* Passport number must be of 8 digits';
            errorCount+=1;
        } else if (!regPassport.test(values.idProofNumber)) {
          errors.idProofNumber = '* Enter valid passport number';
          errorCount+=1;
        }
      }
      if (
        values.idProofType ===
        getDomainData(
          PRD_IDProofTypeForCreditScoreList,
          'PAN Card',
          'value',
          'code',
        )
      ) {
        if (values.idProofNumber.length !== 10) {
          errors.idProofNumber = '* PAN number must be of 10 digits';
          errorCount+=1;
        } else if (
          !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
            values.idProofNumber,
          )
        ) {
          errors.idProofNumber = '* Please enter valid PAN number';
          errorCount+=1;
        }
      }
      //end-------------------------------------------------------
    }
    // if (!values?.pincode) {
    //   errors.pincode = '* Required';
    // } else if (
    //   values.pincode &&
    //   (values.pincode.length !== 6 ||
    //     !values.pincode.match(/^[0-9]+$/))
    // ) {
    //   errors.pincode = '* Pincode must be of 6 digits';
    // } else if (
    //   values.pincode &&
    //   values.pincode.length === 6 &&
    //   !values.state
    // ) {
    //   errors.pincode = '* Click the search icon to fetch state';
    // }
    // console.log("errorserrorserrorserrors",errors)
    if(errorCount===0){
      errors={}
    }
    return errors;
  };

  const update_cover_data = (values) => {
    coversInfo?.applicableCovers?.riskCovers.map((riskCover, idx) =>
      riskCover.covers.map((cover, idx) => {
        cover?.name === values?.addOnCovers;
      }),
    );
  };
  const onSubmit = (values) => {
    setParentAlerts([]);
    updateMotorQuote({
      ...values,
      prevInsurance: {
        insurerName:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.insurerName
            : '',
        policyNumber:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.policyNumber
            : '',
        expiryDate:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.expiryDate
            : '',
        startDate:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.startDate
            : '',
        coverType:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.coverType
            : '',
        policyTenure:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.policyTenure
            : '',
      },
      isPrevInsuranceAvailable:
        values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'no'
          ? null
          : values?.isPrevInsuranceAvailable,
      isPrevClaimsAvailable:
        values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'no'
          ? null
          : values?.isPrevClaimsAvailable,
      policyCoverType:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.policyCoverType
          : '',
      policyTenure:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.policyTenure
          : '',
      policyTenureValue:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.policyTenureValue
          : '',
      policyStartDate:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.policyStartDate
          : '',
      policyExpiryDate:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.policyExpiryDate
          : '',
      totalClaimCount:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' &&
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('annual') !== -1)
          ? values?.totalClaimCount
          : '',
      totalClaimCountValue:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' &&
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('annual') !== -1)
          ? values?.totalClaimCountValue
          : '',
      noOfClaimsOneYear:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' &&
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('long term') !== -1)
          ? values?.noOfClaimsOneYear
          : '',
      noOfClaimsTwoYears:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' &&
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('long term') !== -1)
          ? values?.noOfClaimsTwoYears
          : '',
      noOfClaimsThreeYears:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' &&
          values?.policyTenureValue
            ?.toLowerCase()
            ?.search('long term') !== -1)
          ? values?.noOfClaimsThreeYears
          : '',
      totalClaimAmount:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.totalClaimAmount
          : '',
      previousYearNCBSlab:
        values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' ||
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'used car' &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes')
          ? values?.previousYearNCBSlab
          : '',
      isVehicleDetailsAvailable: true,
      regNo: `${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}${values?.vehicleRegNo?.part3}${values?.vehicleRegNo?.part4}`,
      coverData: {
        addOnCovers :  coversInfo?.applicableCovers?.riskCovers.map((riskCover, idx) => {
            return {
              riskType: riskCover?.riskType,
              covers: riskCover?.covers?.map((cover) => {
                return {
                  name: cover?.name,
                  index: cover?.index,
                selected: (values?.isQuoteCopied && values.businessType!==motorQuote?.businessType &&values?.businessType=='Roll Over')
                ||values.businessType!==motorQuote?.businessType
                ?false
                 :
                !values?.quotationNo 
                  ?
                  values?.vehicleOwnerTypeAndGender?.organisationType=='Individual'
                  &&cover?.name=='Owner Driver'
                  ?true
                  :(values?.fuelType=='CNG'||values?.fuelType=='LPG')
                  &&values?.productVariant?.toLowerCase()?.search('liability')&&cover?.name=='CNG Kit TP'
                  ?true
                  :  values?.addOnCovers !== undefined  && values?.addOnCovers[cover?.name]
                  ? values?.addOnCovers[cover?.name]?.selected 
                  : motorQuote?.coverData?.addOnCovers?.find(
                    (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                      (cov) => cov?.name === cover?.name)?.selected || false
                  : motorQuote?.coverData?.addOnCovers?.find(
                    (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                      (cov) => cov?.name === cover?.name)
                    ? motorQuote?.coverData?.addOnCovers?.find(
                      (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                        (cov) => cov?.name === cover?.name)?.selected
                      : false,
                attributes: !values?.quotationNo
                  ?  (motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                      ?.covers?.find((cov) => (cov?.name === cover?.name && cov?.index === 'N093891G0058') ))
                      ? (motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name && cov?.index === 'N093891G0058')
                          ))?.attributes?.map((e) => {
                            if (e?.displayName === 'No. of passengers') {
                              return {
                                ...e,
                                value: values?.seatingCapacity,
                              }
                            } else {
                              return e;
                            }
                          })
                          : motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) => cov?.name === cover?.name)?.attributes || cover?.attributes
                  : motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                    ?.covers?.find((cov) => cov?.name === cover?.name)
                      ? 
                        motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                        ?.covers?.find((cov) => cov?.name === cover?.name)?.attributes
                      : cover?.attributes
                    ,
              }
            })
          }
              }),
        rawRiskData: coversInfo?.applicableCovers?.riskCovers,
      },
      productCode: productCode1,
      trailerDetails: values?.trailerDetails,
      gvw: values?.gvw,
      carriageType: {
        code: values?.carriageType?.code,
        value: values?.carriageType?.value,
      },
      usageType:{
        code: values?.usageType?.code,
        value: values?.usageType?.value,
      },
      subProduct:{
        code: values?.subProduct?.code,
        value: values?.subProduct?.value,
      },
      typeofCarriage:{
        code: values?.typeofCarriage?.code,
        value: values?.typeofCarriage?.value,
      },
      typeOfBody:values?.typeOfBody,
      permitType: {
        code: values?.permitType?.code,
        value: values?.permitType?.value,
      },
      vehicleuse: {
        code: values?.vehicleuse?.value,
        value: values?.vehicleuse?.value,
      },
      vehiclesubType: {
        code: values?.vehiclesubType?.value,
        value: values?.vehiclesubType?.value,
      },
      carryingCapacity:values?.carryingCapacity,
      isTrailerRequired:values?.isTrailerRequired,
      towedby:values?.towedby,
      totalIDV: values?.productVariant?.toLowerCase()?.search('liability')!==-1
      ?'0'
      :(parseFloat(values?.bodyIDV)+parseFloat(values?.changedIDV))?.toString(),
      changedGVW:values?.changedGVW,
      bodyIDV: values?.productVariant?.toLowerCase()?.search('liability')!==-1
      ?'0'
      :values?.bodyIDV,
      nooftrailers:values?.nooftrailers,
      coverforlamps:values?.coverforlamps,
      coverforprivateandcommercial:values?.coverforprivateandcommercial,
      vehicleusedlimitedtoownpremises:values?.vehicleusedlimitedtoownpremises,
      vehicleuseddrivingtuitions:values?.vehicleuseddrivingtuitions,
      ImportedVehicle:values?.ImportedVehicle,
      ConfinedtoOwnPremises:values?.ConfinedtoOwnPremises,
      SoftCopyDiscount:values?.SoftCopyDiscount,
      AntiTheftDiscount:values?.AntiTheftDiscount,

    });
    if(values?.isProposalModify){
      updateMotorQuote({
        proposalNumber: values?.proposalNumber,
        proposalData:{
          ...values?.proposalData,
          additionalTabDetails: {
            ...values?.proposalData?.additionalTabDetails,
            previousInsuranceAndClaims:{
              previousPolicyDetails: {
                TPpreviousInsurerName: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.TPpreviousInsurerName
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPpreviousInsurerName}`
                :  '',
              TPexpiringPolicyNumber: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.TPexpiringPolicyNumber
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPexpiringPolicyNumber}`
                : '',
              previousInsurerName: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
                : '',
              expiringPolicyNumber: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.expiringPolicyNumber
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
                : '',
              }
            },
          },
          vehicleTabDetails:{
            vehicleRegistrationDetails:{
              engineNumber: values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.engineNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.engineNumber}`
              : '',
            chasisNumber: values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.chasisNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
              : '',
            preInspectionNumber:values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.preInspectionNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
                  ?.preInspectionNumber}`
              :'',
            }
          }
        }
      })
     }
    setproceedToCoverPage(true);
    return true;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  const VehicleForm = ({ validate, coversInfo }) => {
    const { values, setFieldValue, submitForm } =
      useQuantaFormikContext();
    // console.log("values---------959>",values)
    const [loadingBusinessType, setLoadingBusinessType] =
      useState(false);
    const [loadingVehicleDetials, setLoadingVehicleDetials] =
      useState(false);
    const [loadingClaimDetails, setLoadingClaimDetails] =
      useState(false);
    const [errorClaimDetails, setErrorClaimDetails] = useState(null);
    const [errorBusinessType, setErrorBusinessType] = useState(null);
    const [businessType, setBusinessType] = useState(null);
    const [errorFLADetails, setErrorFLADetails] = useState(null);
    const [showVehicleDetailsModal, setShowVehicleDetailsModal] =
      useState(false);
    const [vehicleDetailValues, setVehicleDetailValues] = useState(
      values?.make?.code
        ? {
            make: {
              code: values?.make?.code ? values?.make?.code : '',
              value: values?.make?.value ? values?.make?.value : '',
            },
            variant: {
              variantCode: values?.variant?.code
                ? values?.variant?.code
                : '',
              variantName: values?.variant?.value
                ? values?.variant?.value
                : '',
            },
            model: {
              code: values?.model?.code ? values?.model?.code : '',
              value: values?.model?.value ? values?.model?.value : '',
            },
            seatingCapacity: values?.seatingCapacity
              ? values?.seatingCapacity
              : '',
            gvw: values?.gvw ? values?.gvw : '',
            carryingCapacity: values?.carryingCapacity
              ? values?.carryingCapacity
              : '',
            permitType: {
              code: values?.permitType?.code,
              value: values?.permitType?.value,
            },
            carriageType: {
              code: values?.carriageType?.code,
              value: values?.carriageType?.value,
            },
            usageType:{
              code: values?.usageType?.code,
              value: values?.usageType?.value,
            },
            subProduct:{
              code: values?.subProduct?.code,
              value: values?.subProduct?.value,
            },
            typeofCarriage:{
              code: values?.typeofCarriage?.code,
              value: values?.typeofCarriage?.value,
            },
            typeOfBody:values?.typeOfBody,
            fuelType: values?.fuelType ? values?.fuelType : '',
            vehicleuse: {
              code: values?.vehicleuse?.code,
              value: values?.vehicleuse?.value,
            },
            vehiclesubType: {
              code: values?.vehiclesubType?.code,
              value: values?.vehiclesubType?.value,
            },
            cubeCapacity: values?.cubeCapacity
              ? values?.cubeCapacity
              : '',
            yearOfManufacture: values?.yearOfManufacture
              ? values?.yearOfManufacture
              : '',
            dateOfReg: values?.dateOfReg ? values?.dateOfReg : '',
            rtoLocationCode: values?.rtoLocationCode
              ? values?.rtoLocationCode
              : '',
            rtoLocationDesc: values?.rtoLocationDesc
              ? values?.rtoLocationDesc
              : '',
            rtoAuthorityCode: values?.rtoAuthorityCode
              ? values?.rtoAuthorityCode
              : '',
            registrationNo: values?.regNo ? values?.regNo : '',
            chasisNo: values?.chasisNo ? values?.chasisNo : '',
            engineNo: values?.engineNo ? values?.engineNo : '',
            isRegNoVerified: values?.isRegNoVerified,
            mode: values?.mode,
          }
        : null,
    );
    const vehicleDtls = useRef();
  
    const vehicleDtlsFetch = async ({getVehicleDetails,vehicleRegNo}) =>{
      try {
        if (getVehicleDetails) {
          
          const { part1, part2, part3, part4, bhseries } = vehicleRegNo;
          const rtoBrandYearQuery = fetchQuery({
            query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
            variables: {
              filterMakeList: {
                productCode: productCode1?.toString()?.toLowerCase(),
              },
              type: 'Year of Manufacture',
            },
          });
          const { data: MakeDetails } = await rtoBrandYearQuery;
       
          const { makeList } = MakeDetails;
          const vehicleModelquery = fetchQuery({
            query: MODEL_DETAILS,
            variables: {
              filter: {
                productCode: productCode1?.toString()?.toLowerCase(),
                makeCode: getVehicleDetails?.make?.code,
              },
            },
          });
          const rtoSearchquery = fetchQuery({
            query: GET_RTO_DETAILS,
            variables: {
              input: {
                rtoCode: getVehicleDetails?.rto?.rtoAuthCode?.toString()
                || getVehicleDetails?.rtoAuthorityCode?.toString(),
                productCode: productCode1?.toString()?.toLowerCase(),

              },
            },
          });
            
          const vehicleVariantquery = fetchQuery({
            query: VARIANT_DETAILS,
            variables: {
              filter: {
                productCode: productCode1?.toString()?.toLowerCase(),
                makeCode: getVehicleDetails?.make?.code,
                modelCode: getVehicleDetails?.model?.code,
                vehiclesubclasscode: getVehicleDetails?.vehicleuse?.value.toString()=='C1A PCV 4 Wheeler not exceeding 6 passengers'
              ?'63':
              getVehicleDetails?.vehicleuse?.value.toString()=='C1B PCV 3 Wheeler not exceeding 6 passengers'
              ?'64'
              :getVehicleDetails?.vehicleuse?.value.toString()=='C2A PCV 4 Wheeler exceeding 6-Other Bus'
              ?'65'
              :getVehicleDetails?.vehicleuse?.value.toString()=='C2B PCV 3 Wheeler exceeding 17'
              ?'66'
              :getVehicleDetails?.vehicleuse?.value.toString()=='C3 PCV 3 Wheeler exceeding 6 but 17'
              ?'67' : getVehicleDetails?.vehicleuse?.value.toString()=='C2A PCV 4 Wheeler exceeding 6-School Bus'? '72':''
              },
            },
          });
          
          const { data: modelData } = await vehicleModelquery;
          const { data: variantData } = await vehicleVariantquery;
          const { data: rtoData} = await rtoSearchquery;
          const variantDtls = variantData?.variantList?.find(
            (vl) =>
              vl?.variantName?.trim()?.toLowerCase() ===
              getVehicleDetails?.variant?.code?.trim()
                ?.toLowerCase(),
          );
          vehicleDtls.current = {
            mode: 'online',
            isRegNoVerified: true,
            isMakeDeclined: getVehicleDetails?.isDeclined,
            make: getVehicleDetails?.make,
            model: getVehicleDetails?.model,
            makeList: makeList,
            modelList: modelData?.modelList,
            rtoList:  rtoData?.RTODtlsSearch?.rto,

            variantList: variantData?.variantList,
            variant: {
              code: getVehicleDetails?.variant?.code 
                || getVehicleDetails?.variant?.variantCode ,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.variant?.value 
              ?  `${getVehicleDetails?.model?.value} - ${getVehicleDetails?.variant?.value} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubicCapacity}`
              :  getVehicleDetails?.variant?.variantName?.search(getVehicleDetails?.model?.value) !== -1
                ? `${getVehicleDetails?.variant?.variantName} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubeCapacity}`
              :`${getVehicleDetails?.model?.value} - ${getVehicleDetails?.variant?.variantName} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubeCapacity}`
             },
            fuelType: getVehicleDetails?.fuelType,
            seatingCapacity: getVehicleDetails?.seatingCapacity,
            cubeCapacity: getVehicleDetails?.cubicCapacity,
            yearOfManufacture: getVehicleDetails?.manufactureYear||getVehicleDetails?.yearOfManufacture,
            dateOfReg: getVehicleDetails?.regPurchaseDate||getVehicleDetails?.dateOfReg,
            rtoLocationCode: getVehicleDetails?.rto?.rtoLocCode||getVehicleDetails?.rtoLocationCode,
            rtoLocationDesc: getVehicleDetails?.rto?.rtoLocDesc||getVehicleDetails?.rtoLocationDesc,
            rtoAuthorityCode: getVehicleDetails?.rto?.rtoAuthCode||getVehicleDetails?.rtoAuthorityCode,
            registrationNo: `${part1}${part2}${part3}${part4}`,
            engineNo: getVehicleDetails?.engineNumber,
            chasisNo: getVehicleDetails?.chasisNumber,
            carryingCapacity: getVehicleDetails?.carryingCapacity,
            financerName: getVehicleDetails?.financerName,
            prevInsurance: getVehicleDetails?.prevInsurance,
            rtoAuthAndLocationDesc:
            `${getVehicleDetails?.rto?.rtoAuthCode||getVehicleDetails?.rtoAuthorityCode}-${
              getVehicleDetails?.rto?.rtoLocDesc||getVehicleDetails?.rtoLocationDesc }`?.trim(),
            vehicleuse:{
              code: getVehicleDetails?.
              vehicleuse?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.vehicleuse?.value
             },
             carriageType:{
              code: getVehicleDetails?.
              carriageType?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.carriageType?.value
             },
             vehiclesubType:{
              code: getVehicleDetails?.
              vehiclesubType?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.vehiclesubType?.value
             },
             usageType:{
              code: getVehicleDetails?.
              usageType?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.usageType?.value
             },
             subProduct:{
              code: getVehicleDetails?.
              subProduct?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.subProduct?.value
             },
             typeofCarriage:{
              code: getVehicleDetails?.
              typeofCarriage?.code,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.typeofCarriage?.value
             },

          }
        }
      }
      catch (error) {
        console.log(error);
      }
    }
    const renderExpandedCards = useRef([
      { cardName: 'trailer 1', flag: true },
    ]);
    useEffect(() => {
      if (!values?.vehicleIsOwnedBy) {
        setFieldValue(
          'vehicleIsOwnedBy',
          PRD_vehicleOwnedByList[0]?.code,
        );
        setFieldValue(`vehicleOwnerTypeAndGender`, {
          gender: PRD_vehicleOwnedByList[0]?.code
            ?.split('#')[1]
            ?.trim()
            ? PRD_vehicleOwnedByList[0]?.code?.split('#')[1]?.trim()
            : '',
          organisationType: PRD_vehicleOwnedByList[0]?.code
            ?.split('#')[0]
            ?.trim()
            ? PRD_vehicleOwnedByList[0]?.code?.split('#')[0]?.trim()
            : '',
        });
      }
      // console.log("values?.productType-------------------->", values)
      // if (productCode?.toString() == '3176') {
      //   setFieldValue(`productVariant`, productVariantList?.[1]?.value);
      //   console.log("productVariantList?.[1]?.value", productVariantList?.[1]?.value)
      // }
      // if (productCode?.toString() == '3151') {
      //   setFieldValue(`productVariant`, productVariantList?.[2]?.value);
      // }
      // if (!values?.productVariant) {
      //   setFieldValue(`productVariant`, productVariantList?.[0]?.value,);
      // }

      // if (!values?.productType || !values?.productTypeValue) {
      //   if (values?.productvariant?.toLowerCase()?.search('comprehensive') !== -1) {

      //     setFieldValue(`productType`, lobProductList
      //       ?.find(
      //         (lpl) =>
      //           lpl?.lob_code?.toString()?.toLowerCase() ===
      //           lobCode?.toString()?.toLowerCase(),
      //       )
      //       ?.products?.find(
      //         (prd) =>
      //           prd?.product_code
      //             ?.toString()
      //             ?.toLowerCase() ===
      //           productCode1?.toString()?.toLowerCase(),
      //       )
      //       ?.product_types?.[0]?.value);
      //     setFieldValue(`productType`, lobProductList
      //       ?.find(
      //         (lpl) =>
      //           lpl?.lob_code?.toString()?.toLowerCase() ===
      //           lobCode?.toString()?.toLowerCase(),
      //       )
      //       ?.products?.find(
      //         (prd) =>
      //           prd?.product_code
      //             ?.toString()
      //             ?.toLowerCase() ===
      //           productCode1?.toString()?.toLowerCase(),
      //       )
      //       ?.product_types?.[0]?.code);
      //     setFieldValue(`businessType`, 'Roll Over')
      //     setFieldValue(`anyPreviousPolicyforVehicleTaken`, 'Yes')
      //   }
      //   // else {
      //   //   console.log("inside else");

      //   //   setFieldValue(`productType`, lobProductList
      //   //   ?.find(
      //   //     (lpl) =>
      //   //       lpl?.lob_code?.toString()?.toLowerCase() ===
      //   //       lobCode?.toString()?.toLowerCase(),
      //   //   )
      //   //   ?.products?.find(
      //   //     (prd) =>
      //   //       prd?.product_code
      //   //         ?.toString()
      //   //         ?.toLowerCase() ===
      //   //       productCode?.toString()?.toLowerCase(),
      //   //   )
      //   //   ?.product_types?.[0]?.code);
      //   //    setFieldValue(`productType`, lobProductList
      //   //   ?.find(
      //   //     (lpl) =>
      //   //       lpl?.lob_code?.toString()?.toLowerCase() ===
      //   //       lobCode?.toString()?.toLowerCase(),
      //   //   )
      //   //   ?.products?.find(
      //   //     (prd) =>
      //   //       prd?.product_code
      //   //         ?.toString()
      //   //         ?.toLowerCase() ===
      //   //       productCode?.toString()?.toLowerCase(),
      //   //   )
      //   //   ?.product_types?.[0]?.value);
      //   // }
      // }
      if (
        vehicleDetailValues !== null &&
        vehicleDetailValues !== undefined &&
        values
      ) {
        setFieldValue(
          `make`,
          vehicleDetailValues?.make
            ? vehicleDetailValues?.make
            : {
                code: values?.make?.code,
                value: values?.make?.value,
              },
        );
        setFieldValue(
          `model`,
          vehicleDetailValues?.model
            ? vehicleDetailValues?.model
            : {
                code: values?.model?.code,
                value: values?.model?.value,
              },
        );
        setFieldValue(`variant`, {
          code: vehicleDetailValues?.variant?.variantCode
            ? `${vehicleDetailValues?.variant?.variantCode}`
            : values?.variant?.code,
          value: vehicleDetailValues?.variant?.variantName
            ? vehicleDetailValues?.variant?.variantName?.trim()
            : values?.variant?.value,
        });
        setFieldValue(
          `rtoAuthorityCode`,
          vehicleDetailValues?.rtoAuthorityCode
            ? `${vehicleDetailValues?.rtoAuthorityCode}`
            : values?.rtoAuthorityCode,
        );
        setFieldValue(
          `rtoLocationCode`,
          vehicleDetailValues?.rtoLocationCode
            ? `${vehicleDetailValues?.rtoLocationCode}`
            : values?.rtoLocationCode,
        );
        setFieldValue(
          `rtoLocationDesc`,
          vehicleDetailValues?.rtoLocationDesc
            ? `${vehicleDetailValues?.rtoLocationDesc}`
            : values?.rtoLocationDesc,
        );
        setFieldValue(
          `chasisNo`,
          vehicleDetailValues?.chasisNo
            ? `${vehicleDetailValues?.chasisNo}`
            : values?.chasisNo,
        );
        setFieldValue(
          `engineNo`,
          vehicleDetailValues?.engineNo
            ? `${vehicleDetailValues?.engineNo}`
            : values?.engineNo,
        );
        setFieldValue(
          'financerName',
          vehicleDetailValues?.financerName
            ? `${vehicleDetailValues?.financerName}`
            : values?.financerName,
        );
        setFieldValue(
          `seatingCapacity`,
          vehicleDetailValues?.seatingCapacity
            ? `${vehicleDetailValues?.seatingCapacity?.trim()}`
            : values?.seatingCapacity,
        );
        setFieldValue(
          `carryingCapacity`,
          vehicleDetailValues?.carryingCapacity
            ? `${vehicleDetailValues?.carryingCapacity?.trim()}`
            : values?.carryingCapacity,
        );
        setFieldValue(
          `gvw`,
          vehicleDetailValues?.gvw
            ? `${vehicleDetailValues?.gvw?.trim()}`
            : values?.gvw,
        );
        setFieldValue(`carriageType`, {
          code: vehicleDetailValues?.carriageType?.code
            ? `${vehicleDetailValues?.carriageType?.code}`
            : values?.carriageType?.code,
          value: vehicleDetailValues?.carriageType?.value
            ? vehicleDetailValues?.carriageType?.value
            : values?.carriageType?.value,
        });

        setFieldValue(`usageType`, {
          code: vehicleDetailValues?.usageType?.code
            ? `${vehicleDetailValues?.usageType?.code}`
            : values?.usageType?.code,
          value: vehicleDetailValues?.usageType?.value
            ? vehicleDetailValues?.usageType?.value
            : values?.usageType?.value,
        });
        setFieldValue(`subProduct`, {
          code: vehicleDetailValues?.subProduct?.code
            ? `${vehicleDetailValues?.subProduct?.code}`
            : values?.subProduct?.code,
          value: vehicleDetailValues?.subProduct?.value
            ? vehicleDetailValues?.subProduct?.value
            : values?.subProduct?.value,
        });
        setFieldValue(`typeofCarriage`, {
          code: vehicleDetailValues?.typeofCarriage?.code
            ? `${vehicleDetailValues?.typeofCarriage?.code}`
            : values?.typeofCarriage?.code,
          value: vehicleDetailValues?.typeofCarriage?.value
            ? vehicleDetailValues?.typeofCarriage?.value
            : values?.typeofCarriage?.value,
        });
        setFieldValue(
          `typeOfBody`,
          vehicleDetailValues?.typeOfBody
            ? `${vehicleDetailValues?.typeOfBody}`
            : values?.typeOfBody,
        );
        setFieldValue(
          `cubeCapacity`,
          vehicleDetailValues?.cubeCapacity
            ? `${vehicleDetailValues?.cubeCapacity}`
            : values?.cubeCapacity,
        );
        setFieldValue(
          'fuelType',
          vehicleDetailValues?.fuelType
            ? `${vehicleDetailValues?.fuelType}`
            : values?.fuelType,
        );
        setFieldValue(
          'regNo',
          vehicleDetailValues?.registrationNo
            ? `${vehicleDetailValues?.registrationNo}`
            : values?.regNo,
        );
        setFieldValue(
          'yearOfManufacture',
          vehicleDetailValues?.yearOfManufacture
            ? `${vehicleDetailValues?.yearOfManufacture}`
            : values?.yearOfManufacture,
        );
        setFieldValue(`vehiclesubType`, {
          code: vehicleDetailValues?.vehiclesubType?.code
            ? `${vehicleDetailValues?.vehiclesubType?.code}`
            : values?.vehiclesubType?.code,
          value: vehicleDetailValues?.vehiclesubType?.value
            ? vehicleDetailValues?.vehiclesubType?.value
            : values?.vehiclesubType?.value,
        });
        setFieldValue(`vehicleuse`, {
          code: vehicleDetailValues?.vehicleuse?.code
            ? `${vehicleDetailValues?.vehicleuse?.code}`
            : values?.vehicleuse?.code,
          value: vehicleDetailValues?.vehicleuse?.value
            ? vehicleDetailValues?.vehicleuse?.value
            : values?.vehicleuse?.value,
        });
        setFieldValue(
          'dateOfReg',
          vehicleDetailValues?.dateOfReg
            ? `${vehicleDetailValues?.dateOfReg}`
            : values?.dateOfReg,
        );
      }
      if(vehicleDetailValues !== null &&

      vehicleDetailValues !== undefined &&!vehicleDtls?.current){
        let RegNo = values?.vehicleRegNo;
        let vehicleDetails = {
          ...vehicleDetailValues,
          // variant: {
          //   code: vehicleDetailValues?.variant?.variantCode,
          //   value: vehicleDetailValues?.variant?.variantName,
          // },
          carryingCapacity: values?.carryingCapacity,
          financerName: values?.financerName,
          prevInsurance: values?.prevInsurance,
        }
        vehicleDtlsFetch({
          getVehicleDetails: vehicleDetails,
          vehicleRegNo: RegNo
        })
      }
    }, [vehicleDetailValues]);

    const onFLALookup = async ({ values, setFieldValue }) => {
      const { vehicleRegNo } = values;
      const { part1, part2, part3, part4 } = vehicleRegNo;
      if (
        validate(values)?.regNo ===
         // '* Click the search icon to fetch the Vehicle Details' ||
        !validate(values)?.regNo
      ) {
        setFieldValue('regNo', `${part1}${part2}${part3}${part4}`);
        if (
          part1?.length === 2 &&
          part2?.length === 2 &&
          // part3?.length === 2 &&
          // part3?.length === 2 &&
          (part3?.length >= 0 && part3?.length <= 3) &&
          part4?.length === 4
        ) {
          try {
            setErrorFLADetails(null);
            const flaDetails = fetchQuery({
              query: VEHICLE_DETAILS,
              fetchPolicy: 'network-only',
              variables: {
                input: {
                  regNo: `${part1}${part2}${part3}${part4}`,
                  rtoAuthCode: `${part1}${part2}`,
                  productCode: productCode1
                    ?.toString()
                    ?.toLowerCase(),
                },
              },
            });
            setLoadingVehicleDetials(true);
            const { data } = await flaDetails;
            const { getVehicleDetails } = data;
            const {
              make,
              model,
              variant,
              fuelType,
              seatingCapacity,
              cubicCapacity,
              carryingCapacity,
              rto,
              manufactureYear,
              regPurchaseDate,
              engineNumber,
              chasisNumber,
              financerName,
              prevInsurance,
              gvw,
              carriageType,
              usageType,
              subProduct,
             typeofCarriage,
              typeOfBody,
              permitType,
              vehiclesubType,
              vehicleuse
            } = getVehicleDetails;
            if (
              // prevInsurance &&
              // (prevInsurance?.insurerName ||
              //   prevInsurance?.policyNumber ||
              //   prevInsurance?.expiryDate ||
              //   prevInsurance?.coverType ||
              //   prevInsurance?.startDate ||
              //   prevInsurance?.policyTenure) &&
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'roll over' ||
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'used car'
            ) {
              setFieldValue(
                `anyPreviousPolicyforVehicleTaken`,
                'Yes',
              );
              if (
                prevInsurance?.expiryDate ||
                prevInsurance?.startDate ||
                prevInsurance?.coverType ||
                prevInsurance?.policyTenure
              ) {
                setFieldValue(`isPrevInsuranceAvailable`, true);
              } else {
                setFieldValue(`isPrevInsuranceAvailable`, false);
              }
              setFieldValue(
                `policyExpiryDate`,
                prevInsurance?.expiryDate
                  ? prevInsurance?.expiryDate
                  : '',
              );
              setFieldValue(
                `policyStartDate`,
                prevInsurance?.startDate
                  ? prevInsurance?.startDate
                  : '',
              );
              setFieldValue(
                `policyCoverType`,
                prevInsurance?.coverType
                  ? prevInsurance?.coverType
                  : '',
              );
              setFieldValue(
                `policyTenure`,
                prevInsurance?.policyTenure
                  ? prevInsurance?.policyTenure
                  : '',
              );
              setFieldValue(
                `policyTenureValue`,
                policyTermList?.PRD_PreviousPolicyTermList?.find(
                  (pT) =>
                    pT?.code?.toLowerCase() ===
                    prevInsurance?.policyTenure?.toLowerCase(),
                )?.value,
              );
            }
            setFieldValue(`prevInsurance`, prevInsurance);
            setFieldValue(`isRegNoVerified`, true);
            setFieldValue(`mode`, 'online');
            setVehicleDetailValues({
              mode: 'online',
              isRegNoVerified: true,
              make,
              model,
              variant: {
                variantCode: variant?.code,
                variantName: variant?.value,
              },
              fuelType,
              seatingCapacity,
              cubeCapacity: cubicCapacity,
              yearOfManufacture: manufactureYear,
              dateOfReg: regPurchaseDate,
              rtoLocationCode: rto?.rtoLocCode,
              rtoLocationDesc: rto?.rtoLocDesc,
              rtoAuthorityCode: rto?.rtoAuthCode,
              registrationNo: `${part1}${part2}${part3}${part4}`,
              engineNo: engineNumber,
              chasisNo: chasisNumber,
              carryingCapacity,
              financerName,
              prevInsurance,
              gvw: gvw,
              carriageType: carriageType,
              usageType:usageType,
              subProduct:subProduct,
              typeofCarriage:typeofCarriage,
              typeOfBody:typeOfBody,
              permitType: permitType,
              vehiclesubType:vehiclesubType,
              vehicleuse:vehicleuse
            });
            vehicleDtlsFetch({ getVehicleDetails, vehicleRegNo })

            setLoadingVehicleDetials(false);
            if (
              values?.businessType?.trim()?.toLowerCase() ===
                'roll over' ||
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'used car'
            ) {
              try {
                const fetchClaimDetails = fetchQuery({
                  query: CLAIM_DETAILS,
                  variables: {
                    input: {
                      regNo: `${part1}${part2}${part3}${part4}`,
                      rtoAuthCode: `${rto?.rtoAuthCode}`,
                    },
                  },
                });
                setLoadingClaimDetails(true);
                const { data } = await fetchClaimDetails;
                setLoadingClaimDetails(false);
                if (
                  data?.getClaimDetails?.totalClaimCount ||
                  data?.getClaimDetails?.totalClaimAmount ||
                  data?.getClaimDetails?.claimsInYear1 ||
                  data?.getClaimDetails?.claimsInYear2 ||
                  data?.getClaimDetails?.claimsInYear3 ||
                  data?.getClaimDetails?.prevNCBSlab
                ) {
                  setFieldValue(`isPrevClaimsAvailable`, true);
                } else {
                  setFieldValue(`isPrevClaimsAvailable`, false);
                }
                setFieldValue(
                  `totalClaimCount`,
                  data?.getClaimDetails?.totalClaimCount !== '' &&
                    data?.getClaimDetails?.totalClaimCount !== null &&
                    data?.getClaimDetails?.totalClaimCount !==
                      undefined
                    ? `${data?.getClaimDetails?.totalClaimCount}`
                    : values?.totalClaimCount,
                );
                setFieldValue(
                  `totalClaimAmount`,
                  data?.getClaimDetails?.totalClaimAmount !== null &&
                    data?.getClaimDetails?.totalClaimAmount !==
                      undefined &&
                    data?.getClaimDetails?.totalClaimAmount !== ''
                    ? `${data?.getClaimDetails?.totalClaimAmount}`
                    : values?.totalClaimAmount,
                );
                setFieldValue(
                  `noOfClaimsOneYear`,
                  data?.getClaimDetails?.claimsInYear1 !== null &&
                    data?.getClaimDetails?.claimsInYear1 !==
                      undefined &&
                    data?.getClaimDetails?.claimsInYear1 !== ''
                    ? `${data?.getClaimDetails?.claimsInYear1}`
                    : `${values?.noOfClaimsOneYear}`,
                );
                setFieldValue(
                  `noOfClaimsTwoYears`,
                  data?.getClaimDetails?.claimsInYear2 !== null &&
                    data?.getClaimDetails?.claimsInYear2 !==
                      undefined &&
                    data?.getClaimDetails?.claimsInYear2 !== ''
                    ? `${data?.getClaimDetails?.claimsInYear2}`
                    : `${values?.noOfClaimsTwoYears}`,
                );
                setFieldValue(
                  `noOfClaimsThreeYears`,
                  data?.getClaimDetails?.claimsInYear3 !== null &&
                    data?.getClaimDetails?.claimsInYear3 !==
                      undefined &&
                    data?.getClaimDetails?.claimsInYear3 !== ''
                    ? `${data?.getClaimDetails?.claimsInYear3}`
                    : `${values?.noOfClaimsThreeYears}`,
                );
                setFieldValue(
                  `previousYearNCBSlab`,
                  data?.getClaimDetails?.prevNCBSlab !== null &&
                    data?.getClaimDetails?.prevNCBSlab !==
                      undefined &&
                    data?.getClaimDetails?.prevNCBSlab !== ''
                    ? `${data?.getClaimDetails?.prevNCBSlab}`
                    : `${values?.previousYearNCBSlab}`,
                );
              } catch (error) {
                setLoadingClaimDetails(false);
                setErrorClaimDetails(error.message);
              }
            }
          } catch (error) {
            //setFieldValue(`anyPreviousPolicyforVehicleTaken`, 'No');
            setLoadingVehicleDetials(false);
            setVehicleDetailValues(null);
            setFieldValue(`isRegNoVerified`, false);
            setFieldValue(`mode`, 'online');
            setFieldValue(`make`, {
              code: '',
              value: '',
            });
            setFieldValue(`model`, {
              code: '',
              value: '',
            });
            setFieldValue(`variant`, {
              code: '',
              value: '',
            });
            setFieldValue(`rtoAuthorityCode`, '');
            setFieldValue(`rtoLocationCode`, '');
            setFieldValue(`rtoLocationDesc`, '');
            setFieldValue(`chasisNo`, '');
            setFieldValue(`engineNo`, '');
            setFieldValue('financerName', '');
            setFieldValue(`seatingCapacity`, '');
            setFieldValue(`carryingCapacity`, '');
            setFieldValue(`gvw`, '');
            setFieldValue(`cubeCapacity`, '');
            setFieldValue('fuelType', '');
            setFieldValue('regNo', '');
            setFieldValue('yearOfManufacture', '');
            setFieldValue('dateOfReg', '');
            setFieldValue(`prevInsurance`, {
              insurerName: '',
              policyNumber: '',
              expiryDate: '',
              startDate: '',
              coverType: '',
              policyTenure: '',
            });
            setFieldValue(`policyExpiryDate`, '');
            setFieldValue(`policyStartDate`, '');
            setFieldValue(`policyCoverType`, '');
            setFieldValue(`policyTenure`, '');
            setFieldValue(`policyTenureValue`, '');
            setFieldValue(`isPrevInsuranceAvailable`, false);
            setErrorFLADetails(error?.message);
          }
        }
      }
    };

    const [policyTermList, setPolicyTermList] = useState([]);

    const data = [
      {
        title: 'Product And Business Type',
        grid_data: [
          {
            type: 'select',
            label: (
              <>
                Product Variant<Text severity="error"> *</Text>
              </>
            ),
            name: 'productVariant',
            disabled: (values?.quotationNo !== '' && !modify ),
            data:
              productVariantList && productVariantList?.length > 0
                ? [
                    ...productVariantList?.map((val) => {
                      return {
                        label: val?.value ? `${val.value}` : '',
                        value: val?.code ? `${val.code}` : '',
                      };
                    }),
                  ]
                : [],
            onDataChange: async (val, setFieldValue) => {
              if (
                val?.toLowerCase()?.search('comprehensive') !== -1
              ) {
                //=== 'Car Insurance - Comprehensive') {
                // productCode = '3121'
                setProductCode('3183');
                setproductloading('3183');
                // applicableCoversQuery1()
              } else if (
                val?.toLowerCase()?.search('liability') !== -1
              ) {
                //}=== 'Car Insurance - Liability only') {
                // productCode = '3176'
                setProductCode('3184');
                setproductloading('3184');
                // applicableCoversQuery1()
              }
            },
          },
          // {
          //   type: 'select',
          //   label: (
          //     <>
          //       Product Type<Text severity="error"> *</Text>
          //     </>
          //   ),
          //   name: 'productType',
          //   disabled:
          //     loadingBusinessType || values?.quotationNo !== '',
          //   onDataChange: async (val, setFieldValue) => {
          //     try {
          //       setFieldValue(
          //         `productTypeValue`,
          //         lobProductList
          //           ?.find(
          //             (lpl) =>
          //               lpl?.lob_code?.toString()?.toLowerCase() ===
          //               lobCode?.toString()?.toLowerCase(),
          //           )
          //           ?.products?.find(
          //             (prd) =>
          //               prd?.product_code
          //                 ?.toString()
          //                 ?.toLowerCase() ===
          //               productCode1?.toString()?.toLowerCase(),
          //           )
          //           ?.product_types?.find(
          //             (p) =>
          //               p?.code?.toLowerCase() === val?.toLowerCase(),
          //           )?.value,
          //       );
          //       setFieldValue(
          //         `productType`,
          //         lobProductList
          //           ?.find(
          //             (lpl) =>
          //               lpl?.lob_code?.toString()?.toLowerCase() ===
          //               lobCode?.toString()?.toLowerCase(),
          //           )
          //           ?.products?.find(
          //             (prd) =>
          //               prd?.product_code
          //                 ?.toString()
          //                 ?.toLowerCase() ===
          //               productCode1?.toString()?.toLowerCase(),
          //           )
          //           ?.product_types?.find(
          //             (p) =>
          //               p?.code?.toLowerCase() === val?.toLowerCase(),
          //           )?.code,
          //       );
          //       setErrorBusinessType(null);
          //       setBusinessType(null);
          //       const carSecureBusinessType = fetchQuery({
          //         query: CAR_SECURE_BUSINESS_TYPE,
          //         variables: {
          //           filter: {
          //             productCode,
          //             productType: val?.toString(),
          //           },
          //         },
          //       });
          //       setLoadingBusinessType(true);
          //       const { data: businessTypeData } =
          //         await carSecureBusinessType;
          //       setLoadingBusinessType(false);
          //       setFieldValue(
          //         `businessType`,
          //         businessTypeData?.getCarSecureBusinessType?.code,
          //       );
          //       setFieldValue(
          //         `businessTypeValue`,
          //         businessTypeData?.getCarSecureBusinessType?.value,
          //       );
          //       setBusinessType(
          //         businessTypeData?.getCarSecureBusinessType?.value,
          //       );
          //       if(businessTypeData?.getCarSecureBusinessType?.value
          //         ?.trim()
          //         ?.toLowerCase() === 'used car'){
          //           setFieldValue(
          //             `anyPreviousPolicyforVehicleTaken`,
          //             'No',
          //           );
          //         }
          //       else if (
          //         businessTypeData?.getCarSecureBusinessType?.value
          //           ?.trim()
          //           ?.toLowerCase() === 'roll over' || businessTypeData?.getCarSecureBusinessType?.value
          //             ?.trim()
          //             ?.toLowerCase() === 'used car'
          //         //   &&
          //         // values?.prevInsurance?.insurerName &&
          //         // values?.prevInsurance?.expiryDate &&
          //         // values?.prevInsurance?.policyNumber
          //       ) {
          //         setFieldValue(
          //           `anyPreviousPolicyforVehicleTaken`,
          //           'Yes',
          //         );
          //         if (values?.prevInsurance?.expiryDate) {
          //           setFieldValue(
          //             `policyExpiryDate`,
          //             values?.prevInsurance?.expiryDate,
          //           );
          //         }
          //       } else if (
          //         businessTypeData?.getCarSecureBusinessType?.value
          //           ?.trim()
          //           ?.toLowerCase() === 'new business'
          //       ) {
          //         setFieldValue(
          //           `anyPreviousPolicyforVehicleTaken`,
          //           'No',
          //         );
          //         setFieldValue(`policyCoverType`, '');
          //         setFieldValue(`policyTenure`, '');
          //         setFieldValue(`policyTenureValue`, '');
          //         setFieldValue(`policyStartDate`, '');
          //         setFieldValue(`policyExpiryDate`, '');
          //         setFieldValue(`totalClaimCount`, '');
          //         setFieldValue(`totalClaimCountValue`, '');
          //         setFieldValue(`noOfClaimsOneYear`, '');
          //         setFieldValue(`noOfClaimsTwoYears`, '');
          //         setFieldValue(`noOfClaimsThreeYears`, '');
          //         setFieldValue(`totalClaimAmount`, '');
          //         setFieldValue(`previousYearNCBSlab`, '');
          //       }
          //     } catch (error) {
          //       setLoadingBusinessType(false);
          //       setFieldValue(`businessType`, '');
          //       setErrorBusinessType(error.message);
          //     }
          //   },
          //   data:
          //     lobProductList &&
          //       lobProductList?.length > 0 &&
          //       lobProductList?.find(
          //         (lpl) =>
          //           lpl?.lob_code?.toString()?.toLowerCase() ===
          //           lobCode?.toString()?.toLowerCase(),
          //       )
          //       ? [
          //         ...lobProductList
          //           ?.find(
          //             (lpl) =>
          //               lpl?.lob_code?.toString()?.toLowerCase() ===
          //               lobCode?.toString()?.toLowerCase(),
          //           )
          //           ?.products?.find(
          //             (prd) =>
          //               prd?.product_code
          //                 ?.toString()
          //                 ?.toLowerCase() ===
          //               productCode1?.toString()?.toLowerCase(),
          //           )
          //           ?.product_types?.map((product_type) => {
          //             return {
          //               label: product_type?.value
          //                 ? product_type?.value
          //                 : '',
          //               value: product_type?.code
          //                 ? product_type?.code
          //                 : '',
          //             };
          //           }),
          //       ]
          //       : [],
          // },
          // {
          //   type: 'render',
          //   name: 'businessType',
          //   colSpan:
          //     repeat === repeat_for_mobile ? repeat_for_mobile : null,
          //   component: () => (
          //     <div
          //       className={
          //         repeat === repeat_for_mobile
          //           ? 'flex flex-col items-baseline -mt-2'
          //           : 'flex flex-col mt-2'
          //       }
          //     >
          //       <Text type="label" severity="info">
          //         Business Type
          //       </Text>
          //       {loadingBusinessType && (
          //         <Text
          //           type="normal"
          //           severity="info"
          //           className="flex space-x-2"
          //         >
          //           <Text>
          //             <FontAwesomeIcon icon={faSpinner} spin={true} />
          //           </Text>
          //           <Text>Fetching Business Type</Text>
          //         </Text>
          //       )}
          //       {!loadingBusinessType && errorBusinessType && (
          //         <Text
          //           type="normal"
          //           severity="error"
          //           className="flex space-x-2"
          //         >
          //           <Text>
          //             <FontAwesomeIcon icon={faInfoCircle} />
          //           </Text>
          //           <Text>Error fetching business type</Text>
          //         </Text>
          //       )}
          //       {!loadingBusinessType &&
          //         !errorBusinessType &&
          //         values?.businessType && (
          //           <Text type="normal" className="flex space-x-2">
          //             <Text severity="success">
          //               <FontAwesomeIcon icon={faCheck} />
          //             </Text>
          //             <Text>{values?.businessType}</Text>
          //           </Text>
          //         )}
          //       {!loadingBusinessType &&
          //         !errorBusinessType &&
          //         !values?.businessType && (
          //           <Text type="normal" severity="neutral">
          //             <Text>Not Captured</Text>
          //           </Text>
          //         )}
          //     </div>
          //   ),
          // },
          {
            type: 'select',
            size: 'large',
            label: (
              <>
                Business Type<Text severity="error"> *</Text>
              </>
            ),
            disabled:(values?.quotationNo !== '' && !modify ),
            name: 'businessType',
            data:
              mapdataBusinessType && mapdataBusinessType?.length > 0
                ? [
                    ...mapdataBusinessType?.map((val) => {
                      return {
                        label: val?.value ? `${val.value}` : '',
                        value: val?.code ? `${val.code}` : '',
                      };
                    }),
                  ]
                : [],
          },
          {
            type: 'select',
            size: 'large',
            label: (
              <>
                Vehicle is owned by<Text severity="error"> *</Text>
              </>
            ),
            disabled: (values?.quotationNo !== '' && !modify ),
            name: 'vehicleIsOwnedBy',
            onDataChange: (val, setFieldValue) => {
              setFieldValue(`vehicleOwnerTypeAndGender`, {
                gender: val?.split('#')[1]?.trim()
                  ? val?.split('#')[1]?.trim()
                  : '',
                organisationType: val?.split('#')[0]?.trim()
                  ? val?.split('#')[0]?.trim()
                  : '',
              });
              if (
                getDomainData(
                  PRD_vehicleOwnedByList,
                  val,
                  'code',
                  'value',
                )
                  ?.toString()
                  ?.trim()
                  ?.toLowerCase()
                  ?.startsWith('organisation')
              ) {
                setFieldValue(`getAdditionalCreditScore`, 'No');
                setFieldValue(`idProofType`, '');
                setFieldValue(`idProofNumber`, '');
              }
            },
            data: PRD_vehicleOwnedByList
              ? [
                  ...PRD_vehicleOwnedByList.map(
                    (vehicleIsOwnedBy) => {
                      return {
                        label: vehicleIsOwnedBy.value
                          ? vehicleIsOwnedBy.value
                          : '',
                        value: vehicleIsOwnedBy.code
                          ? vehicleIsOwnedBy.code
                          : '',
                      };
                    },
                  ),
                ]
              : [],
          },
        ],
      },
      {
        title: 'Your Vehicle Details',
        grid_data: [
          values?.vehicleRegNo?.bhseries !== true
            ? {
                type: 'input-wrapper',
                size: 'full',
                fields: [
                  'vehicleRegNo.part1',
                  'vehicleRegNo.part2',
                  'vehicleRegNo.part3',
                  'vehicleRegNo.part4',
                ],
                disabled:
                (values?.quotationNo !== '' && !modify ) || loadingBusinessType,
                className: `${
                  (values?.quotationNo !== '' && !modify )||
                  loadingBusinessType ||
                  loadingVehicleDetials
                    ? 'border-neutral-dark'
                    : ''
                }`,
                children: (
                  <>
                    <QuantaInput
                      name="vehicleRegNo.part1"
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="MH"
                      noerror
                      className="uppercase"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName('vehicleRegNo.part2')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   // part3?.length === 2 &&
                          // part3?.length === 2 &&
                        //   part4?.length === 4
                        // ) {
                        //   // onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `vehicleRegNo.part1`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`isRegNoVerified`, null);
                        vehicleDtls.current = {
                          ...vehicleDtls?.current,
                          rtoList: []
                        }
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify )||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part2"
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="01"
                      noerror
                      disabled={
                        (values?.quotationNo !== '' && !modify )||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onDataChange={(_) =>{
                        setFieldValue(`isRegNoVerified`, null);
                        vehicleDtls.current = {
                          ...vehicleDtls?.current,
                          rtoList: []
                        }
                      }
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName('vehicleRegNo.part3')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   // part3?.length === 2 &&
                          // part3?.length === 2 &&
                        //   part4?.length === 4
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part3"
                  maxLength="3"
                      size="full"
                      type="text"
                  placeholder="CRS"
                      noerror
                      className="uppercase"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onKeyUp={(e) => {
                    if (e.target.value.length === 3) {
                          document
                            .getElementsByName('vehicleRegNo.part4')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        // // part3?.length === 2 &&
                        // part3?.length <= 3 &&
                        //   part4?.length === 4
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `vehicleRegNo.part3`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`isRegNoVerified`, null);
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part4"
                      maxLength="4"
                      size="full"
                      type="text"
                      placeholder="2845"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onDataChange={(_) =>
                        setFieldValue(`isRegNoVerified`, null)
                      }
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   part3?.length === 2 &&
                        //   part4?.length === 4
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      noerror
                    />
                    {/* <QuantaButton
                      type="button"
                      className="w-32"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onClick={async ({
                        values,
                        isValid,
                        setFieldValue,
                      }) => {
                        onFLALookup({ values, setFieldValue });
                      }}
                    >
                      {!loadingVehicleDetials && (
                        <FontAwesomeIcon icon={faSearch} />
                      )}
                      {loadingVehicleDetials && (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin={true}
                        />
                      )}
                    </QuantaButton> */}
                  </>
                ),
                label: (
                  <>
                    Enter Registration Number
                    <Text></Text>
                  </>
                ),
                name: 'regNo',
                // colSpan: repeat,
              }
            : {
                type: 'input-wrapper',
                size: 'full',
                fields: [
                  'vehicleRegNo.part1',
                  'vehicleRegNo.part2',
                  'vehicleRegNo.part3',
                  'vehicleRegNo.part4',
                ],
                disabled:
                  (values?.quotationNo !== '' && !modify )|| loadingBusinessType,
                className: `${
                  (values?.quotationNo !== '' && !modify ) ||
                  loadingBusinessType ||
                  loadingVehicleDetials
                    ? 'border-neutral-dark'
                    : ''
                }`,
                children: (
                  <>
                    <QuantaInput
                      name="vehicleRegNo.part1"
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="21"
                      noerror
                      className="uppercase"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName('vehicleRegNo.part2')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   // part3?.length === 2 &&
                        //   part3?.length === 4 &&
                        //   part4?.length === 2
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `vehicleRegNo.part1`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`isRegNoVerified`, null);
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part2"
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="BH"
                      className="uppercase"
                      noerror
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onDataChange={(_) =>
                        setFieldValue(`isRegNoVerified`, null)
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName('vehicleRegNo.part3')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   // part3?.length === 2 &&
                        //   part3?.length === 4 &&
                        //   part4?.length === 2
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part3"
                      maxLength="4"
                      size="full"
                      type="text"
                      placeholder="0000"
                      noerror
                      className="uppercase"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 4) {
                          document
                            .getElementsByName('vehicleRegNo.part4')
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   part3?.length === 4 &&
                        //   part4?.length === 2
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `vehicleRegNo.part3`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`isRegNoVerified`, null);
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                      } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name="vehicleRegNo.part4"
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="AA"
                      className="uppercase"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onDataChange={(_) =>
                        setFieldValue(`isRegNoVerified`, null)
                      }
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values;
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        // if (
                        //   key === 'Enter' &&
                        //   (validate(values)?.regNo ===
                        //     '* Click the search icon to fetch the Vehicle Details' ||
                        //     !validate(values)?.regNo) &&
                        //   part1?.length === 2 &&
                        //   part2?.length === 2 &&
                        //   part3?.length === 4 &&
                        //   part4?.length === 2
                        // ) {
                        //   onFLALookup({ values, setFieldValue });
                        // }
                      }}
                      noerror
                    />
                    <QuantaButton
                      type="button"
                      className="w-32"
                      disabled={
                        (values?.quotationNo !== '' && !modify ) ||
                        loadingVehicleDetials ||
                        loadingBusinessType
                      }
                      onClick={async ({
                        values,
                        isValid,
                        setFieldValue,
                      }) => {
                        // onFLALookup({ values, setFieldValue });
                      }}
                    >
                      {!loadingVehicleDetials && (
                        <FontAwesomeIcon icon={faSearch} />
                      )}
                      {loadingVehicleDetials && (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin={true}
                        />
                      )}
                    </QuantaButton>
                  </>
                ),
                label: (
                  <>
                    Enter Registration Number
                    <Text></Text>
                  </>
                ),
                name: 'regNo',
                // colSpan: repeat,
              },
          // {
          //   type: 'checkbox',
          //   name: 'vehicleRegNo.bhseries',
          //   disabled: values?.quotationNo !== '',
          //   label: 'BH Registration Number',
          //   onDataChange: async (val, setFieldValue) => {
          //     if (val !== true) {
          //       setFieldValue('vehicleRegNo.part4', '')
          //       setFieldValue('vehicleRegNo.part3', '')
          //       setFieldValue('vehicleRegNo.part2', '')
          //       setFieldValue('vehicleRegNo.part1', '')
          //     }
          //   }
          // },
          // {
          //   type: 'render',
          //   colSpan:
          //     repeat === repeat_for_mobile ? repeat_for_mobile : 2,
          //   component: () => (
          //     <Text
          //       className={
          //         repeat === repeat_for_mobile
          //           ? 'flex items-baseline -mt-2'
          //           : 'flex mt-8 items-center'
          //       }
          //     >
          //       {values?.isRegNoVerified === false && (
          //         <Text className={`flex gap-2 justify-start w-full`}>
          //           <Text severity={'error'}>
          //             <FontAwesomeIcon icon={faExclamation} />
          //           </Text>
          //           <Text severity="error">
          //             We couldn't find any vehicle for input
          //             registration number, please enter manually
          //           </Text>
          //         </Text>
          //       )}
          //       {values?.isRegNoVerified && (
          //         <Text
          //           className={`flex gap-2 justify-start w-full ${
          //             repeat === repeat_for_mobile ? 'my-1' : ''
          //           }`}
          //         >
          //           <Text severity={'success'}>
          //             <FontAwesomeIcon icon={faCheck} />
          //           </Text>
          //           <Text>
          //             We have found below Vehicle details for your
          //             input registration number
          //           </Text>
          //         </Text>
          //       )}
          //     </Text>
          //   ),
          // },
          (!values?.quotationNo || modify )
            ? {
                type: 'render',
                // disabled: true,
                colSpan: repeat,
                component: () =>
                  repeat === repeat_for_desktop ? (
                    <div className="flex flex-row space-x-1 mb-1">
                      <Text>
                        Don't have registration number or manually
                        enter vehicle details?
                      </Text>
                    {(values?.quotationNo === '' || modify)&&( //check
                        <Text
                          className="quanta_link"
                          onClick={(_) => {
                            setShowVehicleDetailsModal(true);
                            if(values?.mode?.toString()?.toLowerCase() !== 'online'){
                            setFieldValue(`policyExpiryDate`, '');
                            setFieldValue(`policyStartDate`, '');
                            setFieldValue(`policyCoverType`, '');
                            setFieldValue(`policyTenure`, '');
                            setFieldValue(`policyTenureValue`, '');
                            setFieldValue(`prevInsurance`, {
                              insurerName: '',
                              policyNumber: '',
                              expiryDate: '',
                              startDate: '',
                              coverType: '',
                              policyTenure: '',
                            });
                          }
                        }
                        }
                        >
                          Click Here
                        </Text>
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-row space-x-1 mb-1">
                      <Text>
                        Don't have registration number or manually
                        enter vehicle details?{' '}
                        <Text
                          className="quanta_link"
                          onClick={(_) => {
                            setShowVehicleDetailsModal(true);
                            if(values?.mode?.toString()?.toLowerCase() !== 'online'){

                            setFieldValue(`policyExpiryDate`, '');
                            setFieldValue(`policyStartDate`, '');
                            setFieldValue(`policyCoverType`, '');
                            setFieldValue(`policyTenure`, '');
                            setFieldValue(`policyTenureValue`, '');
                            setFieldValue(`prevInsurance`, {
                              insurerName: '',
                              policyNumber: '',
                              expiryDate: '',
                              startDate: '',
                              coverType: '',
                              policyTenure: '',
                            });
                          }
                        }
                        }                        >
                          Click Here
                        </Text>
                      </Text>
                    </div>
                  ),
              }
            : null,
          vehicleDetailValues || values?.make?.code
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <VehicleDetails
                    vehicleDetailValues={vehicleDetailValues}
                    {...{
                      lobCode,
                      lobName,
                      productCode1,
                      productName,
                      quoteNumber,
                      businessType,
                    }}
                  />
                ),
              }
            : null,
        ].filter((d) => d),
      },
      (values?.businessType &&
        values?.businessType?.trim()?.toLowerCase() ===
          'roll over') ||
      values?.businessType?.trim()?.toLowerCase() === 'used car'
        ? {
            title: 'Previous Insurance & Claims',
            grid_data: [
              {
                type: 'radiogroup',
                label:
                  values?.businessType
                    ?.toString()
                    ?.trim()
                    ?.toLowerCase() === 'used car' ? (
                    <>
                      Was there any policy previously taken for the
                      vehicle?
                    </>
                  ) : (
                    <>
                      Was there any policy previously taken for the
                      vehicle?<Text severity="error"> *</Text>
                    </>
                  ),
                colSpan: repeat,
                name: 'anyPreviousPolicyforVehicleTaken',
                disabledGlobal:
                (values?.quotationNo !== '' && !modify ) ||
                  values?.businessTypeValue?.toLowerCase() ===
                    'used car',
                data: [
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ],
              },
              values?.anyPreviousPolicyforVehicleTaken === 'Yes' ||
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'used car'
                ? {
                    type: 'render',
                    colSpan: repeat,
                    component: () => (
                      <PreviousInsurance
                        productCode={productCode1}
                        productName={productName}
                        lobCode={lobCode}
                        lobName={lobName}
                        quoteNumber={quoteNumber}
                        setPolicyTermList={setPolicyTermList}
                        modify={modify}
                      />
                    ),
                  }
                : null,
              values?.anyPreviousPolicyforVehicleTaken === 'Yes' ||
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'used car'
                ? //  &&
                  //   values?.policyTenure
                  {
                    type: 'render',
                    colSpan: repeat,
                    component: () => (
                      <PreviousClaims
                        productCode={productCode1}
                        productName={productName}
                        lobCode={lobCode}
                        lobName={lobName}
                        quoteNumber={quoteNumber}
                        policyTenure={
                          policyTermList &&
                          policyTermList?.PRD_PreviousPolicyTermList
                            ? getDomainData(
                                policyTermList?.PRD_PreviousPolicyTermList,
                                values?.policyTenure,
                                'code',
                                'value',
                              )
                            : ''
                        }
                        policyTerm={values?.policyTerm}
                        branding={branding}
                        modify={modify}
                      />
                    ),
                  }
                : null,
            ].filter((d) => d),
          }
        : null,
      productCode1.toString() === '3151' &&
      values?.anyPreviousPolicyforVehicleTaken === 'Yes'
        ? // &&  values?.policyCoverType!=='OD Only'
          {
            title: 'TP Policy details',
            grid_data: [
              {
                type: 'render',
                colSpan: repeat === repeatForDesktop ? 1 : repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Grid
                      flow="cols"
                      repeat={
                        repeat === repeatForDesktop ? 1 : repeat
                      }
                      gap={4}
                      className="w-full"
                    >
                      <GridItem
                        colSpan={
                          repeat === repeatForDesktop ? 1 : repeat
                        }
                        className="px-3"
                      >
                        <QuantaDateInput
                          size={'full'}
                          label={
                            <Text type="label">
                              Start Date
                              <Text severity="error"> *</Text>
                            </Text>
                          }
                          name={'TP_Start_Date'}
                          calendarPosition={'top'}
                          onDataChange={async (
                            val,
                            setFieldValue,
                          ) => {
                            setFieldValue(
                              `TP_End_Date`,
                              moment(val, 'DD/MM/YYYY')
                                .add(5, 'year')
                                .subtract(1, 'day')
                                .format('DD/MM/YYYY'),
                            );
                          }}
                          scrollStopWhenCalendarOpen={false}
                        />
                      </GridItem>
                    </Grid>
                  </div>
                ),
              },
              {
                type: 'date',
                disabled: (values?.quotationNo !== '' && !modify ),
                label: <Text type="label">End Date</Text>,
                name: `TP_End_Date`,
              },
            ],
          }
        : null,
        productCode1?.toString() !== '3184'
        ?
      {
        title: 'Insured Declared Value',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <InsuredDeclaredForm
                productCode={productCode1}
                productName={productName}
                lobCode={lobCode}
                lobName={lobName}
                quoteNumber={quoteNumber}
                makeCode={values?.make?.code}
                varientCode={values?.variant?.code}
                rtoCode={values?.rtoLocationCode}
                setFieldValue={setFieldValue}
                branding={branding}
                dateOfReg={values?.dateOfReg} //SAIDVissue
                modify={modify}
                pastPolicyExpiryDate={values?.policyExpiryDate}
                anyPreviousPolicyforVehicleTaken={values?.anyPreviousPolicyforVehicleTaken}
                businessType={values?.businessTypeValue
                || values?.businessType}
                vehicleUsevalue={values?.vehicleuse?.value}
              />
            ),
          },
        ],
      }:null,
      // {
      //   // title: 'Add-On-Covers',
      //   grid_data: [
      //     {
      //       type: 'render',
      //       colSpan: repeat,
      //       component: () => (
      //         <>
      //           <CoversForm
      //             tenureList={coversInfo?.applicableCovers?.tenure}
      //             riskCovers={coversInfo?.applicableCovers?.riskCovers}
      //             productCode={productCode1}
      //             productName={productName}
      //             lobCode={lobCode}
      //             lobName={lobName}
      //             quoteNumber={quoteNumber}
      //             motorQuote={motorQuote}
      //             selectedIntermediary={selectedIntermediary}
      //             fieldUserList={fieldUserList}
      //             setFieldValue={setFieldValue}
      //             characterLimitList={characterLimitList}
      //             forwardedCoversFormRef={props?.forwardedCoversFormRef}

      //           />
      //         </>
      //       ),
      //     },
      //   ].filter((d) => d),
      // },
      // {
      //   title: 'Trailers Details',
      //   grid_data: [

      //       {
      //         type: 'checkbox',
      //         size: 'large',
      //         label: (
      //           <>
      //             Is trailer Required ?<Text severity="error"> </Text>
      //           </>
      //         ),
      //         name: 'isTrailerRequired',
      //         disabled: values?.quotationNo !== '',
      //         onDataChange: (val, setFieldValue) => {
      //           setFieldValue(`nooftrailers`,'');
      //           setFieldValue(`towedby`,'');

      //       }
      //     }
      //     ,
      //     {
      //       type: 'select',
      //       size: 'large',
      //       label: (
      //         <>	No of Trailers under Tow at any time<Text></Text>
      //         </>
      //       ),
      //       name: 'nooftrailers',
      //       disabled: values?.quotationNo !== '' || values?.isTrailerRequired!==true,

      //       data: mapdatanooftrailers &&
      //         mapdatanooftrailers?.length > 0
      //         ? [...mapdatanooftrailers?.map((val) => {
      //           return {
      //             label: val?.value
      //               ? `${val.value}`
      //               : '',
      //             value: val?.code
      //               ? `${val.code}`
      //               : '',
      //           }

      //         }),

      //         ]
      //         : [],
      //       className: `${values?.quotationNo !== '' ? 'border-neutral-dark' : ''
      //         }`,

      //       iconPre: (
      //         <Text
      //           severity={
      //             values?.quotationNo !== '' ? 'neutral-darker' : 'info'
      //           }
      //         >
      //         </Text>
      //        )
      //        },
      //        {
      //         type: 'select',
      //         size: 'large',
      //         label: (
      //           <>Towed By<Text></Text>
      //           </>
      //         ),
      //         name: 'towedby',
      //         disabled: values?.quotationNo !== ''|| values?.isTrailerRequired!==true,
      //         className: `${values?.quotationNo !== '' ? 'border-neutral-dark' : ''
      //           }`,
      //         iconPre: (
      //           <Text
      //             severity={
      //               values?.quotationNo !== '' ? 'neutral-darker' : 'info'
      //             }
      //           >
      //           </Text>
      //         ),
      //         data: mapdatatowedby &&
      //           mapdatatowedby?.length > 0
      //           ? [...mapdatatowedby?.map((val) => {
      //             return {
      //               label: val?.value
      //                 ? `${val.value}`
      //                 : '',
      //               value: val?.code
      //                 ? `${val.code}`
      //                 : '',
      //             }

      //           }),

      //           ]
      //           : [],
      //       },
      //     values?.isTrailerRequired ?
      //     {
      //       type: 'render',
      //       colSpan: repeat,
      //       component: () => (
      //         <>
      //           <Trailers
      //             branding={branding}
      //             {...{
      //               lobCode,
      //               productCode: productCode1,
      //               productName,
      //               lobName,
      //               quoteNumber,
      //                renderExpandedCards,
      //                isTrailerRequired :values?.isTrailerRequired  ,
      //                nooftrailers : values?.nooftrailers
      //             }}
      //           />
      //         </>
      //       ),
      //     }
      //     :null,
      //   ].filter((d) => d),
      // },
      {
        title: 'Other Loading and Discounts',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <>
                <Discounts
                  branding={branding}
                  {...{
                    lobCode,
                    productCode: productCode1,
                    productName,
                    lobName,
                    quoteNumber,
                    modify:modify
                    // renderExpandedCards
                  }}
                />
                <IRFForm
                  productCode={productCode1}
                  productName={productName}
                  lobCode={lobCode}
                  lobName={lobName}
                  quoteNumber={quoteNumber}
                  makeCode={values?.make?.code}
                  varientCode={values?.variant?.code}
                  rtoCode={values?.rtoLocationCode}
                  setFieldValue={setFieldValue}
                  branding={branding}
                  dateOfReg={values?.dateOfReg} //SAIDVissue
                  modify={modify}
                  pastPolicyExpiryDate={values?.policyExpiryDate}
                  anyPreviousPolicyforVehicleTaken={values?.anyPreviousPolicyforVehicleTaken}
                  businessType={values?.businessTypeValue
                  || values?.businessType}
                  vehicleUsevalue={values?.vehicleuse?.value}
                />
              </>
            ),
          },
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      // useExpandablePaper:true
    };

    // const other_props1 = {
    //   flow: 'cols',
    //   repeat,
    //   gapX: 6,
    //   gapY: 0,
    //   spaceY: 2,
    //   size: 'full',
    //   titleSeverity: 'info',
    //   useExpandablePaper:true
    // };
    // const data1 = [
    //   {
    //      title: 'Additional Details',
    //     grid_data: [
    //       {
    //         type: 'render',
    //         colSpan: repeat,
    //         component: () => (
    //           <Discounts
    //             branding={branding}
    //             {...{
    //               lobCode,
    //               productCode,
    //               productName,
    //               lobName,
    //               quoteNumber,
    //               // renderExpandedCards
    //             }}
    //           />
    //         ),
    //       },
    //     ].filter((d) => d),
    //   },
    // ].filter((d) => d);

    return (
      <div>
        <QuantaForm className="space-y-4">
          <MixedGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
        {/* <MixedGridGroup {...{ data:data1, ...other_props1 }} /> */}
        <VehicleDataModal
          vehicleRegNo={`${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}${values?.vehicleRegNo?.part3}${values?.vehicleRegNo?.part4}`}
          engineNo={values?.engineNo}
          chasisNo={values?.chasisNo}
          setParentFieldValue={setFieldValue}
          {...{
            setShowVehicleDetailsModal,
            showVehicleDetailsModal,
            setVehicleDetailValues: setVehicleDetailValues,
            vehicleDtls:vehicleDtls,
            businessType,
            productCode:productCode1,
            productName,
            lobCode,
            lobName,
            quoteNumber,
            submitForm,
          }}
        />
      </div>
    );
  };
  return (
    <>
      <div>
        {!initialValues && (
          <div className="min-h-screen">
            <Loading />
          </div>
        )}
        {initialValues && (
          <QuantaFormik
            innerRef={props?.forwardedRef}
            enableReinitialize={true}
            {...{
              initialValues,
              validate,
              onSubmit,
            }}
          >
            <VehicleForm {...{ validate, coversInfo }} />
          </QuantaFormik>
        )}
      </div>
    </>
  );
}
